module.exports = __webpack_public_path__ + "static/media/carnewiconselected.725dccf7.svg";